var map = {
	"./Avatar1.svg": 8739,
	"./Risorsa 10.svg": 3317,
	"./Risorsa 11.svg": 8596,
	"./Risorsa 12.svg": 1719,
	"./Risorsa 15.svg": 1912,
	"./Risorsa 16.svg": 747,
	"./Risorsa 17.svg": 1690,
	"./Risorsa 18.svg": 2813,
	"./Risorsa 19.svg": 3100,
	"./Risorsa 20.svg": 3484,
	"./Risorsa 21.svg": 2029,
	"./Risorsa 22.svg": 9934,
	"./Risorsa 23.svg": 2511,
	"./Risorsa 24.svg": 5040,
	"./Risorsa 25.svg": 9841,
	"./Risorsa 27.svg": 1139,
	"./Risorsa 28.svg": 4100,
	"./Risorsa 29.svg": 9029,
	"./Risorsa 30.svg": 6335,
	"./Risorsa 31.svg": 8398,
	"./Risorsa 32.svg": 9117,
	"./Risorsa 33.svg": 3660,
	"./Risorsa 34.svg": 4051,
	"./Risorsa 35.svg": 9826,
	"./Risorsa 36.svg": 225,
	"./Risorsa 37.svg": 3312,
	"./Risorsa 38.svg": 8519,
	"./Risorsa 39.svg": 2070,
	"./Risorsa 40.svg": 3094,
	"./Risorsa 41.svg": 2071,
	"./Risorsa 42.svg": 7620,
	"./Risorsa 4_1.svg": 6690,
	"./Risorsa 5.svg": 3131,
	"./Risorsa 6.svg": 5064,
	"./Risorsa 7.svg": 425,
	"./Risorsa 8.svg": 638,
	"./Risorsa 9.svg": 5279,
	"./avatar2.svg": 2704,
	"./avatar3.svg": 7089
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2046;